import { useEffect, useState, useRef } from 'react';

export type ScrollDirection = 'up' | 'down' | null;

export function useScrollDirection(threshold = 10): ScrollDirection {
  const [scrollDir, setScrollDir] = useState<ScrollDirection>(null);
  const lastScrollY = useRef(0);

  useEffect(() => {
    lastScrollY.current = window.scrollY;

    const handleScroll = () => {
      const scrollY = window.scrollY;
      
      // Prevent running if scroll difference is too small
      if (Math.abs(scrollY - lastScrollY.current) < threshold) {
        return;
      }

      // Handle bounce scrolling on iOS/macOS (negative scroll or scrolling past body height)
      if (scrollY < 0) {
        setScrollDir('up');
        return;
      }
      
      const direction = scrollY > lastScrollY.current ? 'down' : 'up';
      setScrollDir(direction);
      lastScrollY.current = scrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return scrollDir;
}
